<template lang="pug">
.ride-card-container
  template(v-if="cardData && cardData.length && cardSceneCheckFinished && !isLoading && !isError")
    component(
      v-for="(item, index) in cardData"
      :keyValue="index"
      :is="componentMap[item.moduleCode]"
      :class="item.className"
      :moduleData="item.moduleData"
      :tryingCardData="item.moduleData && item.moduleData.tryingCardData || {}"
      :rideMoneyData="rideMoneyData"
      :newTabCode="newTabCode"
      @buyCard="buyCard"
      @buyMember="buyMember"
      @rideMoneyData="getRideMoneyData"
  )
  //- 骨架屏
  CardLoadingModule(v-if="isLoading")
  //- 异常场景
  AbnormalPage(
    v-if="cardData.length === 0 || isError"
    :abnormalText="sceneState.abnormalText"
    :buttonText="sceneState.buttonText"
    @refresh="refresh"
  )
  buyCardModal(
    :show.sync="showBuyCardModal"
    :buyCardData="buyCardData"
    :agreementInfo="agreementInfo"
  )
  //-  购买单车卡 | 0.01元升级
  buyMemberModal(
    ref="buyMemberModal"
    :show.sync="showBuyMemberModal"
    :buyMemberData="buyMemberData"
    @showRead="showReadFn"
    :isnew="isUpgrade"
    :isUpgrade="isUpgrade"
    :propVersion="propVersion")
  readModal(
    :show="showRead"
    @close="showRead=false"
    @readOk="readOk"
)
  scrollGift(v-if="tabCode === 'bike'")
</template>
<script>
/* eslint-disable no-param-reassign */
import { getUserDimension, getTWCards } from '@/api/card';
import { getVersion, getSystemCode } from '@/utils/systemCode';
import {
  getTokenAndLocation, getTWCardPlatform, tryCatch, safeGet,
} from '@/utils';
import myRideCard from './my-ride-card';
import rideCardList from './ride-card-list';
import buyCardModal from './buy-card-modal';
import buyMemberModal from './buy-member-modal';
import readModal from '../read-modal.vue';
import rideMmberBlockC from './ride-member-blockC.vue';
import scrollGift from './scroll-gift.vue';
import { ParamsUtil } from '../../../../../utils/params';
import CardLoadingModule from './card-loading-module.vue';
import AbnormalPage from './abnormal-page.vue';
import { RIDE_CARD_COMPONENT_MAP, BUSINESS_TYPE_MAP } from '../../../consts';

export default {
  components: {
    myRideCard,
    rideCardList,
    buyCardModal,
    buyMemberModal,
    readModal,
    rideMmberBlockC,
    scrollGift,
    CardLoadingModule,
    AbnormalPage,
  },
  props: {
    rideCardData: {
      type: Array,
      default() {
        return [];
      },
    },
    propVersion: {
      type: String,
      default: '',
    },
    newTabCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      env: process.env,
      componentMap: RIDE_CARD_COMPONENT_MAP,
      moduleInfos: [],
      showBuyCardModal: false,
      buyCardData: [],
      showBuyMemberModal: false,
      showRead: false,
      buyMemberData: {},
      cardData: [],
      cardDataS: [],
      rideMoneyData: null,
      isUpgrade: false,
      // 购卡协议模块信息
      agreementInfo: {
        isShowAgreement: false,
      },
      cardSceneCheckFinished: false, // 购卡协议模块信息查询完毕
      activeTabKey: 'bike',
      isLoading: true,
      isError: false,
      sceneState: {
        abnormalText: '',
        buttonText: '',
      },
      channelCodeList: [],
    };
  },
  provide() {
    return {
      getAgreementInfo: () => this.agreementInfo,
    };
  },
  inject: ['newH5Version', 'latestTabCode'],
  computed: {
    tabCode() {
      return this.latestTabCode();
    },
  },
  watch: {
    rideCardData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.cardData = val;
        if (this.newH5Version()) {
          if (val && val.length > 0) {
            this.loadRideCardData(val);
          } else {
            this.cardData = [];
            this.sceneState.abnormalText = '当前城市暂不售卖';
          }
        } else {
          this.cardData = val;
        }
      },
    },
  },
  created() {
  },
  mounted() {
    // watch 会在组件创建时立即执行（immediate: true），所以这里只需要处理空数据的情况
    if (!this.rideCardData || this.rideCardData.length === 0) {
      this.init();
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    init() {
      const pageSubTyingCardModule = this.cardData.find((module) => module.moduleCode === 'page_sub_tying_card_module');
      if (pageSubTyingCardModule) {
        const moduleData = pageSubTyingCardModule.moduleData || {};
        this.cardSceneCheck({ channelCode: moduleData.channelCode });
      } else {
        this.cardSceneCheckFinished = true;
      }
    },
    showReadFn() {
      this.showRead = true;
    },
    buyMember(val, isUpgrade = false) {
      this.buyMemberData = val;
      this.showBuyMemberModal = true;
      this.isUpgrade = isUpgrade;
    },
    buyUpgrade(val) {
      this.buyMember(val, true);
    },
    buyCard(val) {
      if (Array.isArray(val)) {
        this.buyCardData = val;
      } else {
        this.buyCardData = [val];
      }
      this.showBuyCardModal = true;
      // getNoScroll(true);
    },
    readOk() {
      this.$refs.buyMemberModal.readOk();
    },
    getRideMoneyData(val) {
      this.rideMoneyData = val;
    },
    /**
     * 用户维度业务场景校验（判断是否需要展示购卡协议）
     */
    async cardSceneCheck(option) {
      try {
        let { channelCode } = option;
        const { token, adCode, cityCode } = await getTokenAndLocation();
        if (typeof channelCode === 'string') {
          channelCode = Number(channelCode);
        }
        const tabCode = this.latestTabCode() || 'bike';
        const result = await getUserDimension({
          token,
          adCode,
          cityCode,
          sceneType: 'purchaseAgreement',
          businessType: BUSINESS_TYPE_MAP[tabCode],
          channelCode,
          version: await getVersion(),
        });
        this.agreementInfo = this.agreementInfoAdapter(result.data);
        this.cardSceneCheckFinished = true;
      } catch (error) {
        this.cardSceneCheckFinished = true;
      }
    },
    /**
     * 合规命中接口数据处理
     * @param data 合规命中返回的数据
     * @typedef {Object} AgreementInfo
     * @property {boolean} isShowAgreement - 是否展示购卡协议
     * @property {string} agreementUrl - 购卡协议链接
     * @property {string} agreementTitle - 协议标题
     * @returns { AgreementInfo } 格式化数据
     */
    agreementInfoAdapter(data) {
      let agreementInfo = {
        isShowAgreement: false,
        agreementUrl: '',
        agreementTitle: '',
      };
      if (data.agreementInfo) {
        agreementInfo = {
          ...data.agreementInfo,
          isShowAgreement: data.agreementInfo.gray,
          agreementUrl: data.agreementInfo.clickUrl,
          agreementTitle: data.agreementInfo.title,
        };
      }
      return agreementInfo;
    },
    /**
     * 加载骑行卡数据
     */
    async loadRideCardData(moduleInfos) {
      this.isError = false;
      // 深拷贝避免修改原始数据
      const processedModuleInfos = JSON.parse(JSON.stringify(moduleInfos));
      // 处理数据
      try {
        await this.getRidePageData(processedModuleInfos);
        // 赋值给 cardData
        this.cardData = processedModuleInfos;
        if (!this.cardData || this.cardData.length === 0) {
          this.sceneState.abnormalText = '当前城市暂不售卖';
        }
        this.isLoading = false;
        // 初始化购卡协议检查
        this.init();
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
        this.sceneState.abnormalText = '加载异常，请稍后再试';
        this.sceneState.buttonText = '刷新';
      }
    },
    /**
     * 获取骑行卡页面数据
     */
    async getRidePageData(moduleInfos) {
      try {
        // 处理vip推荐模块和骑行卡数据
        this.processVipRecommendModules(moduleInfos);

        // 处理骑行卡list模块数据
        this.processModuleInfos(moduleInfos);

        if (this.channelCodeList.length > 0) {
          const uniqueChannelCodes = [...new Set(this.channelCodeList)];
          const rideCardResults = await this.getRideCardData(uniqueChannelCodes);

          // 将获取到的数据分配到对应模块
          this.distributeRideCardData(moduleInfos, rideCardResults);
        }
      } catch (error) {
        // 错误处理逻辑
        const errcode = safeGet(window, '__error.code', null);
        if (errcode === 600) {
          this.sceneState.abnormalText = '当前城市暂不售卖';
        } else {
          this.sceneState.abnormalText = '加载异常，请稍后再试';
          this.sceneState.buttonText = '刷新';
        }
        this.isError = true;
      }
      return moduleInfos;
    },
    /**
     * 将获取到的骑行卡数据分配到对应模块
     */
    distributeRideCardData(moduleInfos, rideCardResults) {
      moduleInfos.forEach((module) => {
        if (!module.moduleData) return;

        const moduleChannelCode = module.moduleData && module.moduleData.channelCode;
        if (!moduleChannelCode) return;

        // 查找匹配的数据
        const matchedData = rideCardResults.find(
          (item) => String(item.channelCode) === String(moduleChannelCode),
        );

        switch (module.moduleCode) {
          case 'page_sub_tying_card_module':
            if (module._tyingRelation) {
              // 如果存在main和sub模块关系
              const subData = rideCardResults.find(
                (item) => String(item.channelCode) === String(module._tyingRelation.subChannelCode),
              );
              const mainData = rideCardResults.find(
                (item) => String(item.channelCode) === String(module._tyingRelation.mainChannelCode),
              );

              module.moduleData = {
                ...module.moduleData,
                ...(subData || {}),
                changeChoose: module._tyingRelation.subChannelCode,
                tryingCardData: {
                  ...(module.moduleData.tryingCardData || {}),
                  ...(mainData || {}),
                  channelCode: module._tyingRelation.mainChannelCode,
                },
                channelCode: module._tyingRelation.subChannelCode,
              };
            } else {
              // 没有旧版vip推荐模块时，直接更新模块数据
              module.moduleData = {
                ...module.moduleData,
                ...matchedData,
                channelCode: moduleChannelCode,
              };
            }
            break;

          case 'page_main_tying_card_coupon_visualization_module':
          {
            // 优惠券可视化模块
            const mergedData = {
              ...module.moduleData,
              ...matchedData,
              channelCode: moduleChannelCode,
            };
            module.moduleData = {
              ...mergedData,
              rideMoneyData: this.getRideMoney(mergedData.packages),
            };
            break;
          }

          default:
            // 其他模块直接更新 moduleData
            module.moduleData = {
              ...module.moduleData,
              ...matchedData,
              channelCode: moduleChannelCode,
            };
            break;
        }
      });
    },
    /**
     * 获取骑行卡数据（API调用）
     */
    async getRideCardData(channelCodeList = []) {
      const { adSource } = ParamsUtil.getParams(window.location.href);
      const { token, cityCode, adCode } = await getTokenAndLocation();
      try {
        const res = await getTWCards({
          token,
          adCode,
          cityCode,
          businessId: this.tabCode === 'bike' ? 0 : 1, // 单车
          channelCodes: channelCodeList,
          platform: getTWCardPlatform(),
          version: await getVersion(),
          systemCode: getSystemCode(),
          adSource,
        });
        const data = tryCatch(() => res.data.packageGroups, null);
        return data;
      } catch (error) {
        throw new Error();
      }
    },
    processVipRecommendModules(moduleInfos) {
      // 没有旧版vip推荐模块，处理 sub tying card 模块的试骑卡数据
      const mainTyingModule = moduleInfos.find((info) => info.moduleCode === 'page_main_tying_card_module');
      if (mainTyingModule && mainTyingModule.moduleData) {
        // 直接遍历原始 moduleInfos 数组
        moduleInfos.forEach((module) => {
          if (module.moduleCode === 'page_sub_tying_card_module') {
            const subChannelCode = module.moduleData.channelCode;
            const mainChannelCode = mainTyingModule.moduleData.channelCode;
            this.channelCodeList.push(subChannelCode, mainChannelCode);

            // 添加一个标识，记录main和sub模块关系
            if (!module._tyingRelation) {
              module._tyingRelation = {
                subChannelCode,
                mainChannelCode,
              };
            }
          }
        });
      }
    },
    /**
     * 处理我的卡、骑行卡list模块数据
     */
    processModuleInfos(moduleInfos) {
      moduleInfos.forEach((module) => {
        if (!module || !module.moduleData) return;

        switch (module.moduleCode) {
          case 'page_sub_tying_card_module':
          // 处理 sub tying card 模块（只在没有 旧版vip 推荐模块时）
          {
            const { channelCode = '' } = module.moduleData;
            if (!channelCode) return;
            this.channelCodeList.push(channelCode);
            break;
          }

          case 'page_main_tying_card_coupon_visualization_module':
            // 处理优惠券可视化 tying card 模块
            {
              const { channelCode } = module.moduleData;
              this.channelCodeList.push(channelCode);
            }
            break;

          default:
            break;
        }
      });
    },
    /**
     * 获取骑行卡金额
     */
    getRideMoney(rideData) {
      // 获取
      let temppackages = '';
      if (rideData && rideData.length > 0) {
        // 这里怎么是ride 哪来的 是bike？
        if (this.tabCode === 'ride') {
          const temp = rideData.find((item) => item.paymentLimit === 1);
          if (temp) {
            temppackages = temp;
          }
        } else {
          const temp = rideData.find((item) => item.paymentLimit === 0);
          if (temp) {
            temppackages = temp;
          }
        }
        return (temppackages.actualPrice && temppackages.actualPrice.finalPrice) || '';
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.ride-card-container {
  padding-bottom: 0.93rem;
  margin-top: 0.09rem;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
    color: transparent;
  }
}
</style>
